import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay before showing
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25 }}
          className="fixed bottom-0 left-0 right-0 z-[8500] bg-[#1A2E1F] border-t-2 border-[#C9A84C] px-4 py-4 sm:py-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-[#E8DCC8] text-sm text-center sm:text-left">
              We use cookies to improve your experience on our site. By continuing to browse, you agree to our use of cookies.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="/privacy"
                className="px-4 py-2 border border-[#C9A84C] text-[#C9A84C] text-sm font-medium rounded-sm hover:bg-[#C9A84C]/10 transition-colors"
              >
                Learn More
              </a>
              <button
                onClick={handleAccept}
                data-testid="cookie-accept-btn"
                className="px-6 py-2 bg-[#C9A84C] text-[#0D0D0D] text-sm font-semibold rounded-sm hover:bg-[#E8D89A] transition-colors"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
